import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { FeatureLockModal, showFeatureLockModal, FeatureLockData } from '../ui/diary/FeatureLockModal';

interface MountOptions {
  /** URL to subscription page */
  subscriptionUrl: string;
  /** Translations for modal content */
  translations: {
    featureLocked: string;
    featureLockedDescription: string;
    requirement: string;
    subscribe: string;
    seeAchievement: string;
    maybeLater: string;
  };
}

// Store root reference for cleanup
let root: Root | null = null;

export function mountFeatureLockModal(container: HTMLElement, options: MountOptions): void {
  // Clean up previous root if it exists
  if (root) {
    root.unmount();
  }

  root = createRoot(container);
  root.render(
    <FeatureLockModal subscriptionUrl={options.subscriptionUrl} translations={options.translations} />
  );
}

export function unmountFeatureLockModal(): void {
  if (root) {
    root.unmount();
    root = null;
  }
}

// Re-export the show function for external use
export { showFeatureLockModal };
export type { FeatureLockData };
